import { Directive, ElementRef, HostListener } from '@angular/core'

export function selectContents (element: HTMLInputElement|HTMLTextAreaElement) {
  if ('select' in (element as any)) {
    element.focus()
    element.select()
  } else if ('setSelectionRange' in element) {
    element.setSelectionRange(0, 999)
  } else {
    const range = document.createRange()
    range.setStartBefore(element[0])
    range.setEndAfter(element[0])
    const sel = window.getSelection()
    sel?.removeAllRanges()
    sel?.addRange(range)
  }
}

@Directive({
  selector: '[autoselect]',
})
export class AutoselectDirective {
  constructor (
    private element: ElementRef<HTMLInputElement|HTMLTextAreaElement>,
  ) { }

  @HostListener('click') onClick () {
    selectContents(this.element.nativeElement)
  }
}
